import { connect } from 'react-redux'

import { actions as LKModalActions } from 'shared/LKModal'

import { actions as DetailsContainerActions } from '../../../../DetailsContainer'
import { translateLKMessage } from '../../../translator'
import { deleteOfficer, deleteOfficerLoading } from 'src/store/loan'

const FETCHER_NAME = 'DeleteLoanOfficer'

export default connect(
  (state) => ({
    // loading: getPending(FETCHER_NAME)(state),
    loading: deleteOfficerLoading(state),
  }),
  (dispatch, { ID, hash }) => ({
    openConfirmation: (ManagerID) => {
      dispatch(
        LKModalActions.openConfirmation('DeleteLoanOfficerConfirmation', {
          message: translateLKMessage('CONFIRM_LOAN_MANAGER_REMOVE'),
          ManagerID,
        }),
      )
    },

    deleteOfficer: ({ ManagerID }) => {
      // dispatch(
      //   fetchSFM({
      //     instanceName: FETCHER_NAME,
      //     callApi: Loan.deleteOfficer,
      //     callApiArgs: [
      //       {
      //         LoanID: ID,
      //         HashSum_LoanID_: hash,
      //         ManagerID,
      //       },
      //     ],
      //     resolve: () => {
      //       dispatch(DetailsContainerActions.fetchPage({ type: 'Loan', ID, hash, page: 'officer' }))
      //     },
      //     reject: ({ Error }) => {
      //       if (Error.Text === 'ERR_LOAN_DELETE_LAST_MANAGER') {
      //         dispatch(LKModalActions.openInfo(translateLKMessage(Error.Message || Error.Text)))
      //       } else {
      //         dispatch(LKModalActions.openError(translateLKMessage(Error.Message || Error.Text)))
      //       }
      //     },
      //   }),
      // )
      //UPDATED API REQUEST loan_view_api page: officerdelete
      dispatch(
        deleteOfficer({
          LoanID: ID,
          HashSum_LoanID_: hash,
          ManagerID,
        }),
      ).then((response) => {
        if (!deleteOfficer.fulfilled.match(response)) {
          if (response.payload === 'ERR_LOAN_DELETE_LAST_MANAGER') {
            dispatch(LKModalActions.openInfo(translateLKMessage(response.payload)))
          } else {
            dispatch(LKModalActions.openError(translateLKMessage(response.payload)))
          }
          return
        }
        dispatch(DetailsContainerActions.fetchPage({ type: 'Loan', ID, hash, page: 'officer' }))
      })
    },
  }),
)
